import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoCredenciada'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const REEmpreendimentoCredenciada = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/REEmpreendimentoCredenciada/${id} `, data, config)
const GetAllEnterpriseAccredited = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEnterpriseAccredited/${id}`, data, config)
const GetAllPaging = (id, limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEnterpriseAccredited/${id}?limit=${limit}&index=${index}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id} `, data, config)
const GetAllByNotEmpreendimento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllByNotEmpreendimentoId/${id} `, data, config)
const GetUnboundEnterprises = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetUnboundEnterprises/${id} `, data, config)
const SendNewCredenciada = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SendNewCredenciada/${id} `, data, config)
const Add = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const PostEmpreendimentoCredenciada = (empreendimentoId, credenciadaId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/PostEmpreendimentoCredenciada/${empreendimentoId}/${credenciadaId}`, data, config)
const DeleteEnterpriseAccredited = (id, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)

const EnterpriseAccreditedRepository = {
  REEmpreendimentoCredenciada,
  GetAllEnterpriseAccredited,
  GetAllPaging,
  Delete,
  GetAllByNotEmpreendimento,
  GetUnboundEnterprises,
  SendNewCredenciada,
  Add,
  PostEmpreendimentoCredenciada,
  DeleteEnterpriseAccredited
}

export default EnterpriseAccreditedRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/enterpriseaccredited.js